export const CloseToMaintenanceDays = 30;

export enum MaintenanceStatusEnum {
    Regular = 0,
    CloseToMaintenance = 1,
    MaintenanceRequired = 2,
}

export function MaintenanceStatusEnumToLabel(status: MaintenanceStatusEnum): string {
    switch (status) {
        case MaintenanceStatusEnum.Regular:
            return "enum.maintenanceStatus.regular";
        case MaintenanceStatusEnum.CloseToMaintenance:
            return "enum.maintenanceStatus.closeToMaintenance";
        case MaintenanceStatusEnum.MaintenanceRequired:
            return "enum.maintenanceStatus.maintenanceRequired";
        default:
            return "common.unknown";
    }
}

export function GetMachineMaintenanceStatusIconColor(status: MaintenanceStatusEnum) {
    switch (status) {
        case MaintenanceStatusEnum.Regular:
            return {
                icon: "check",
                color: "success",
            };
        case MaintenanceStatusEnum.CloseToMaintenance:
            return {
                icon: "exclamation-triangle",
                color: "warning",
            };
        case MaintenanceStatusEnum.MaintenanceRequired:
            return {
                icon: "exclamation-triangle",
                color: "error",
            };
        default:
            break;
    }
}
